<app-header [sub_titulo]="editando? 'Editando validación' : 'Nueva validación'" path="/config/validaciones"></app-header>

<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
    <div id="menus" style="min-height: 95vh; height: auto">
        <div class="card-body-content" style="width: 99%; min-height: 90%; max-height: 99%; height: 90%">
            <br />
            <mat-card style="height: 99%">
                <div class="nuevo-asistente-container">
                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Código (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="codigo">
                        </app-campo-default-admin>
                    </div>
                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Nombre (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="nombre">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-generic-select (ngModelChange)="cambioTipoValidacion($event)" [options]="opcionesTipo"
                            placeholder="Tipo (*)" [(ngModel)]="tipo">
                        </app-generic-select>
                    </div>

                    <div *ngFor="let campo of camposTipoValidacion">
                        <div class="form-group">
                            <app-campo-default-admin [descripcion_etiqueta]="campo.etiqueta"
                                placeholder_input="Este campo es obligatorio" [(ngModel)]="campo.valor"
                                [type]="campo.tipo">
                            </app-campo-default-admin>
                        </div>
                    </div>

                    <div class="form-field-align" *ngIf="this.editando">
                        <label for="habilitado">Habilitado (*)</label>
                        <mat-slide-toggle [(ngModel)]="habilitado"></mat-slide-toggle>
                    </div>

                    <app-mensaje-error *ngIf="error" [mensaje_error]="error"></app-mensaje-error>
                    <div class="fin">
                        <app-boton-primario [disabled]="loading" [spinner]="loading"
                            [boton_texto]="loading ? 'Guardando' : 'Guardar'"
                            (boton_funcion)="applyOperation()"></app-boton-primario>
                        <button mat-raised-button  (click)="volver()">Cancelar</button>    
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</mat-card>